import React from 'react'
import Select, { OptionTypeBase, ValueType } from 'react-select'
import * as Form from '../../../Form'
import { Spinner } from '../../../Spinner'
import { Field, FormFacade, FieldInterceptChange, InterceptChangeEvent } from '../../types'

// @ts-expect-error
export type ReactSelectValue = ValueType<OptionTypeBase>

interface Props {
  id?: string
  field?: Field<HTMLInputElement, ReactSelectValue>
  form?: FormFacade
  interceptChange?: FieldInterceptChange<ReactSelectValue>
  label?: string
  options?: OptionTypeBase[]
  placeholder?: string
  isDisabled: boolean
  isLoading: boolean
  isRequired: boolean
}

export const ReactSelect = ({
  id,
  field,
  form,
  interceptChange,
  label,
  options,
  placeholder = 'Select',
  isRequired,
  isLoading,
  isDisabled
}: Props) => {
  const { name, value } = field ?? {}
  const { errors, touched, setFieldValue, setFieldTouched } = form ?? {}
  const hasError = name && errors?.[name] && touched?.[name]
  const _id = id ?? name

  const setFormikFieldValue = (value: ReactSelectValue) => {
    if (name) {
      setFieldValue?.(name, value ?? [], false)
      setFieldTouched?.(name, true, true)
    }
  }

  const handleChange = (value: ReactSelectValue) => {
    if (!name || !form) {
      return
    }

    const changeEvent: InterceptChangeEvent<ReactSelectValue> = {
      value,
      name,
      form
    }

    const shouldIntercept = interceptChange?.(changeEvent)

    if (!shouldIntercept) {
      setFormikFieldValue(value)
    }
  }

  const handleBlur = () => {
    if (name) {
      setFieldTouched?.(name, true, true)
    }
  }

  return (
    <Form.Field
      className={`form-field form-field--react-select ${hasError ? 'form-has-error' : ''}`}
      hasError={hasError}
    >
      {label && (
        <Form.Label htmlFor={_id}>
          <span>{label}</span>
          {isRequired && <em>*</em>}
        </Form.Label>
      )}

      <Form.ReactSelectTheme.Wrapper
        hasError={hasError}
      >
        <Select
          inputId={_id}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          isDisabled={isDisabled}
          options={options}
          classNamePrefix={Form.ReactSelectTheme.classNamePrefix}
        />
      </Form.ReactSelectTheme.Wrapper>

      {isLoading && (
        <Spinner size={20} />
      )}

      {hasError && name && (
        <Form.Error>
          {errors?.[name]}
        </Form.Error>
      )}
    </Form.Field>
  )
}
